import Head from 'next/head'
import type { ReactNode } from 'react'
import { HeaderBase } from 'shared/components/header/components/header-base'
import { HeaderLogo } from 'shared/components/header/components/header-logo'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface PublicLayoutProps {
  browserTabTitle: string
  children: ReactNode
}

export function PublicLayout({ browserTabTitle, children }: PublicLayoutProps) {
  const { t } = useLocoTranslation()

  return (
    <>
      <Head>
        <title>{t(browserTabTitle)}</title>
      </Head>
      <HeaderBase>
        <HeaderLogo />
      </HeaderBase>
      <div className="px-4 sm:px-6 md:px-14">
        <main className="py-5">{children}</main>
      </div>
    </>
  )
}
